/**
 * Cookie 管理サービス
 * Cookie の取得・設定・削除・期限延長を一元管理する
 */

// 各 Cookie の有効期限設定（日数）
const COOKIE_EXPIRY_DAYS = {
  bkms_cloud_auth: 30,
  bkms_cloud_pin: 30,
  bkms_cloud_url: 365,
  bkms_terms_agreed: 365,
  bkms_pub_terms_agreed: 30,
  bkms_publish_id: 365
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;

// HTTPS環境かどうかを判定（Secureフラグの付与に使用）
function isSecureContext() {
  return typeof location !== 'undefined' && location.protocol === 'https:';
}

// Cookie属性の共通サフィックスを生成
function cookieFlags() {
  return isSecureContext() ? ';SameSite=Lax;Secure' : ';SameSite=Lax';
}

/**
 * Cookie を設定する
 * @param {string} name Cookie 名
 * @param {string} value Cookie 値
 * @param {number} daysToExpire 有効期限（日数）
 */
export function setCookie(name, value, daysToExpire = 365) {
  const date = new Date();
  date.setTime(date.getTime() + daysToExpire * MS_PER_DAY);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/' + cookieFlags();
}

/**
 * Cookie を取得する（存在する場合は有効期限を自動延長）
 * @param {string} name Cookie 名
 * @returns {string} Cookie 値（存在しない場合は空文字）
 */
export function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    const value = decodeURIComponent(match[2]);
    extendCookieExpiry(name, value);
    return value;
  }
  return '';
}

/**
 * Cookie を取得する（有効期限延長なし）
 * @param {string} name Cookie 名
 * @returns {string} Cookie 値（存在しない場合は空文字）
 */
export function getCookieDirectly(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : '';
}

/**
 * Cookie の有効期限を延長する
 * @param {string} name Cookie 名
 * @param {string} value Cookie 値
 */
export function extendCookieExpiry(name, value) {
  const daysToExpire = COOKIE_EXPIRY_DAYS[name];
  if (daysToExpire) {
    setCookie(name, value, daysToExpire);
  }
}

/**
 * アプリケーション起動時に全 Cookie の有効期限を延長する
 */
export function extendAllCookiesOnStartup() {
  Object.keys(COOKIE_EXPIRY_DAYS).forEach(cookieName => {
    const cookieValue = getCookieDirectly(cookieName);
    if (cookieValue) {
      extendCookieExpiry(cookieName, cookieValue);
    }
  });
}

/**
 * クラウド関連の Cookie を削除する
 */
export function clearCloudCookies() {
  const flags = cookieFlags();
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/' + flags;
  document.cookie = 'bkms_cloud_url=;' + expired;
  document.cookie = 'bkms_cloud_auth=;' + expired;
  document.cookie = 'bkms_cloud_pin=;' + expired;
}

export default {
  setCookie,
  getCookie,
  getCookieDirectly,
  extendCookieExpiry,
  extendAllCookiesOnStartup,
  clearCloudCookies
};
